import i18n from 'modules/core/lib/i18n'

import { parseConfigurationJson } from 'modules/inbox_tasks/tasks/employeeLifecycleStepAction/helpers'

export const getDataInputMetadata = (configurationJson?: string | null): string[] => {
  const config = parseConfigurationJson(configurationJson)

  if (config?.mandatory === true) {
    return [i18n.t('common.mandatory')]
  }

  return []
}
